import { useAppMutation } from '@/hooks/api';
import { API_ROUTES } from '@/constants/api-routes';
import mutationKeys from '@/constants/mutationKeys';

interface ValidateDeleteTemplateResponse {
  isAllowed: boolean;
}

export const useValidateDeleteTemplateMutation = (templateId: string) => {
  return useAppMutation<ValidateDeleteTemplateResponse>({
    routeName: API_ROUTES.VALIDATE_DELETE_TEMPLATE.replace(':templateId', templateId),
    mutationKey: [mutationKeys.TEMPLATE_GALLERY_VALIDATE_DELETE_TEMPLATE],
    method: 'POST',
  });
};